import React, { Dispatch, SetStateAction } from "react"
import {
  InputActionBonus,
  InputActionGiftCard,
  InputActionPaymentCancellation,
  InputActionType, OrderCancellation,
} from "lib/types/generated/graphql-types"
import {
  ActionWrapper,
  GiftCardInputWrapper,
  Label,
  LabelWrapper,
  StyledActionDropdownButton
} from "./CancellationAction.styled"
import ActionInfoBox from "../../../OperationsDashboard/OperationActions/ActionInfoBox"
import { ActionDropdownButton } from "../../../Ui/Buttons/ActionDropdownButton"
import { ReactComponent as GiftCardIcon } from "images/icons/gift.svg"
import { ReactComponent as BonusIcon } from "images/icons/hand-holding-dollar.svg"
import { ReactComponent as PaymentIcon } from "images/icons/credit-card.svg"
import Input from "../../../Ui/Form/Input"


type ActionState = {
  giftCardAction: InputActionGiftCard
  setGiftCardAction: Dispatch<SetStateAction<InputActionGiftCard>>
  bonusAction: InputActionBonus
  setBonusAction: Dispatch<SetStateAction<InputActionBonus>>
  paymentAction: InputActionPaymentCancellation
  setPaymentAction: Dispatch<SetStateAction<InputActionPaymentCancellation>>
}

type Props = {
  cancellation: OrderCancellation
  actionState: ActionState
  orderId: string
}

const CancellationAction = ({ actionState, cancellation }: Props) => {
  const {
    giftCardAction,
    setGiftCardAction,
    bonusAction,
    setBonusAction,
    paymentAction,
    setPaymentAction
  } = actionState


  const updateGiftCardActionCards = (id: string, value: string) => {
    const idExists = giftCardAction?.giftCards?.find((giftCard) => giftCard.giftCardId === id)
    if (idExists) {
      return setGiftCardAction({
        ...giftCardAction,
        giftCards: giftCardAction?.giftCards?.map((giftCard) =>
          giftCard.giftCardId === id
            ? {
                giftCardId: id,
                transactionId: value
              }
            : giftCard
        )
      })
    }
    return setGiftCardAction({
      ...giftCardAction,
      giftCards: [...(giftCardAction.giftCards ?? []), { giftCardId: id, transactionId: value }]
    })
  }

  const updatePaymentCaptureReference = (reference: string) => {
    setPaymentAction({ ...paymentAction, reference: reference })
  }

  const capitalize = (s: string) => s && s[0].toUpperCase() + s.slice(1)
  const getLabel = (value: string) => capitalize(value.toLowerCase())

  return (
    <div>
      <Label>Actions:</Label>
      <ActionInfoBox />
      <div>
        {cancellation?.giftCards?.length > 0 && (
          <div>
            <ActionWrapper>
              <LabelWrapper>
                <GiftCardIcon />
                <b>GiftCard - {cancellation?.giftCardProvider?.providerName}</b>
              </LabelWrapper>
              <ActionDropdownButton title={getLabel(giftCardAction.actionType)}>
                <li onClick={() => setGiftCardAction({ actionType: InputActionType.Auto })}>
                  Auto
                </li>
                <li onClick={() => setGiftCardAction({ actionType: InputActionType.Manual })}>
                  Manual
                </li>
                <li onClick={() => setGiftCardAction({ actionType: InputActionType.Skip })}>
                  Skip
                </li>
              </ActionDropdownButton>
            </ActionWrapper>
            {giftCardAction.actionType === InputActionType.Manual && (
              <>
                {cancellation.giftCards.map((giftCard) => {
                  return (
                    <GiftCardInputWrapper key={giftCard.giftCardId}>
                      <p>{giftCard.giftCardId}</p>
                      <Input
                        removePaddingBottom={true}
                        name="transactionId"
                        placeholder="Transaction id"
                        onChange={(e: React.FormEvent<HTMLInputElement>) =>
                          updateGiftCardActionCards(giftCard.giftCardId, e.currentTarget.value)
                        }
                      />
                    </GiftCardInputWrapper>
                  )
                })}
              </>
            )}
          </div>
        )}
        {cancellation?.bonus && (
          <div>
            <ActionWrapper>
              <LabelWrapper>
                <BonusIcon />
                <b>Bonus - {cancellation?.bonusProvider?.providerName}</b>{" "}
              </LabelWrapper>
              <ActionDropdownButton title={getLabel(bonusAction.actionType)}>
                <li onClick={() => setBonusAction({ actionType: InputActionType.Auto })}>Auto</li>
                <li onClick={() => setBonusAction({ actionType: InputActionType.Manual })}>
                  Manual
                </li>
                <li onClick={() => setBonusAction({ actionType: InputActionType.Skip })}>Skip</li>
              </ActionDropdownButton>
            </ActionWrapper>
          </div>
        )}
        <ActionWrapper>
          <LabelWrapper>
            <PaymentIcon />
            <b>Payment - {cancellation?.paymentProvider?.providerName}</b>
          </LabelWrapper>
          <StyledActionDropdownButton title={getLabel(paymentAction.actionType)}>
            <li onClick={() => setPaymentAction({ actionType: InputActionType.Auto })}>Auto</li>
            <li onClick={() => setPaymentAction({ actionType: InputActionType.Manual })}>Manual</li>
            <li onClick={() => setPaymentAction({ actionType: InputActionType.Skip })}>Skip</li>
          </StyledActionDropdownButton>
        </ActionWrapper>
        {paymentAction.actionType === InputActionType.Manual && (
          <Input
            name="captureReference"
            label="Capture reference"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              updatePaymentCaptureReference(e.currentTarget.value)
            }
          />
        )}
      </div>
    </div>
  )
}

export default CancellationAction
